export default {
  index: [
    {
      path: '/qysetmeal',
      component: resolve => require(['./qysetmealIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qysetmeal/_router.js